var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v("©2025 Gabriel Gnatowski")])
}
var staticRenderFns = []

export { render, staticRenderFns }